export default [
  {
    path: "/crypto",
    component: () => import(/* webpackChunkName: "layout" */ "./layout"),

    children: [
      {
        path: "/",
        name: "crypto.transactions",
        component: () => import(/* webpackChunkName: "crypto" */ "./transactions/"),
      },
      {
        path: "withdrawals",
        name: "crypto.withdrawals",
        component: () => import(/* webpackChunkName: "crypto" */ "./withdrawals"),
      },
      {
        path: "rates",
        name: "crypto.rates",
        component: () => import(/* webpackChunkName: "crypto" */ "./rates"),
      },
      {
        path: "cryptoCurrencies",
        name: "crypto.cryptoCurrencies",
        component: () => import(/* webpackChunkName: "crypto" */ "./currencies/crypto"),
      },
      {
        path: "traditionalCurrencies",
        name: "crypto.traditionalCurrencies",
        component: () => import(/* webpackChunkName: "crypto" */ "./currencies/traditional"),
      },
      {
        path: "limits",
        name: "crypto.limits",
        component: () => import(/* webpackChunkName: "crypto" */ "./limits"),
      },

      {
        path: ":id",
        props: true,
        name: "crypto.transactions.show",
        component: () => import(/* webpackChunkName: "crypto" */ "./transactions/details"),
      },
    ],
  },
];
